export default __webpack_public_path__ + "f1c18ddb39cf8470ee77224a5fe79ec8.svg";